import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/themes/base/datepicker.css';
import templePriceModals from './temple-price-modal';

const body = document.querySelector('body');
const mq_sds = "(max-width:1024px)"
const mq_ns = "(max-width:880px)"
const mq_lg = "(max-width:960px)"


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/
class Modal {
  constructor(obj) {
    this.modalOpenCN = 'is-open';
    this.bodyOpenCN = 'is-modal-open';
    this.modalCN = obj?.modalElm ?? '.js-modal';
    this.openBtnCN = obj?.modalOpenElm ?? '[data-modal-open]';
    this.modalIDattr = 'data-modal-id';
    this.modalCont = document.querySelectorAll(this.modalCN);
    this.closeBtn = document.querySelectorAll('[data-modal-close]');
    this.init();
  }

  init() {
    this.modalCont.forEach(modal => { modal.style.display = 'none'; });
    this.openModal();
    this.closeBtn.forEach(btn => {
      btn.addEventListener('click', (e) => { this.closeModal(); });
    });
  }

  openModal() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(this.openBtnCN);
      if (!btn) return;
      const modal_id = btn.getAttribute(this.modalIDattr);
      if (!modal_id) return;

      const ids = modal_id.split(',').map(id => id.trim());
      ids.forEach(id => this.openModalById(id));
    });
  }

  openModalById(id) {
    const targetModal = document.querySelector(`${this.modalCN}[${this.modalIDattr}="${id}"]`);
    if (!targetModal) return;

    document.body.classList.add(this.bodyOpenCN);
    targetModal.setAttribute('aria-hidden', 'false');
    targetModal.style.display = 'flex';
    setTimeout(() => targetModal.classList.add(this.modalOpenCN), 100);
  }

  closeModal() {
    this.modalCont.forEach(modal => {
      if (!modal.classList.contains(this.modalOpenCN)) return;

      modal.classList.remove(this.modalOpenCN);
      modal.setAttribute('aria-hidden', 'true');

      setTimeout(() => {
        modal.style.display = 'none';

        // bodyのクラスはまだ開いているモーダルがあれば残す
        const anyOpen = Array.from(this.modalCont).some(m => m.classList.contains(this.modalOpenCN));
        if (!anyOpen) document.body.classList.remove(this.bodyOpenCN);
      }, 500);
    });
  }
}


/*---------------------------------------------------------------------------------
  debounce
---------------------------------------------------------------------------------*/


const _debounce = (func, delay) => {
  let timer = 0;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(null, args), delay);
  }
}


window.onload = () => {
  scrollAnime();
};


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/


const scrollAnime = () => {
  const elems = document.querySelectorAll('.js-fadein');
  if (!elems.length) return;

  elems.forEach(elem => {
    const elRmg = elem.dataset.rmgn || '-20% 0px';
    const options = {
      root: null,
      rootMargin: `${elRmg}`,
      threshold: parseFloat(elem.dataset.threshold) || 0,
    };

    let observer;

    if(elem.hasAttribute('data-stagger')) {
      observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          const stagger = elem.dataset.stagger || 300;
          const items =  elem.querySelectorAll('.js-fadein-stagger');
          if (entry.isIntersecting) {
            items.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add('is-show');
              }, index * stagger);
            });
            observer.unobserve(entry.target);
          }
        });
      }, options);
    } else {
      observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-show');
            observer.unobserve(entry.target);
          }
        });
      }, options);
    }

    observer.observe(elem);
  });
};




/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const subNaiHandler = () => {
  const elms = document.querySelectorAll('.js-has-subnavi');
  const mql = window.matchMedia(mq_sds);
  let controller = new AbortController();

  const initClass = () => {
    elms.forEach(elm => {
      elm.classList.remove('is-open', 'is-hoverStyle');
    });
  };

  const toggleOpenClass = () => {
    elms.forEach(elm => {
      const btn = elm.querySelector('.js-btn');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        elm.classList.toggle('is-open');
      }, { signal: controller.signal });
    });
  };

  const handlePCTap = () => {
    elms.forEach(elm => {
      const btn = elm.querySelector('.js-btn');
      if (!btn) return;
      btn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        elm.classList.toggle('is-hoverStyle');
      }, { signal: controller.signal });
      elm.addEventListener('mouseenter', () => {
        elm.classList.add('is-hoverStyle');
      }, { signal: controller.signal });
      elm.addEventListener('mouseleave', () => {
        elm.classList.remove('is-hoverStyle');
      }, { signal: controller.signal });
    });
  };

  const listener = (event) => {
    controller.abort();
    controller = new AbortController();
    initClass();

    if (event.matches) {
      // SP処理
      toggleOpenClass();
    } else {
      // PC処理
      handlePCTap();
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
};



/*---------------------------------------------------------------------------------
  Mobile gavi
---------------------------------------------------------------------------------*/

const mobileGnavi = () => {
  const mql = window.matchMedia(mq_sds);
  const menuBtn = document.querySelector('.js-menu-btn');
  const navi = document.querySelector('.gnavi');
  const closeBtn = navi?.querySelector('.gnavi__close');
  const openClass = 'is-gnavi-open';
  let activeAction = true;
  if (!menuBtn || !navi) return;

  const handleClick = (event) => {
    event.preventDefault();
    if (activeAction) {
      body.classList.toggle(openClass);
      if (body.classList.contains(openClass)) {
        naviOpen();
      } else {
        naviClose();
      }
    }
  };

  const naviOpen = () => {
    activeAction = false;
    menuBtn.classList.add('is-show');
    body.classList.add('is-no-scroll');
    navi.style.display = 'flex';
    navi.querySelectorAll('.js-has-subnavi').forEach(elm => elm.classList.add('is-open'));
    setTimeout(function () {
      navi.classList.add('is-open');
      activeAction = true;
    }, 100);
  }

  const naviClose = () => {
    activeAction = false;
    menuBtn.classList.remove('is-show');
    body.classList.remove('is-no-scroll');
    navi.classList.remove('is-open');
    setTimeout(function () {
      navi.style.display = 'none';
      activeAction = true;
    }, 600);
  }

  const listener = (event) => {
    if (event.matches) {
      // SP用処理
      navi.style.display = 'none';
      menuBtn.removeEventListener('click', handleClick);
      menuBtn.addEventListener('click', handleClick);
      if (closeBtn) {
        closeBtn.removeEventListener('click', handleClick);
        closeBtn.addEventListener('click', handleClick);
      }
    } else {
      // PC用ブレークポイント用処理
      navi.style.display = '';
      body.classList.remove('is-no-scroll','is-gnavi-open');
      menuBtn.classList.remove('is-show');
      activeAction = true;
      menuBtn.removeEventListener('click', handleClick);
      if (closeBtn) {
        closeBtn.removeEventListener('click', handleClick);
      }
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
}



/*---------------------------------------------------------------------------------
  Accordion Box
---------------------------------------------------------------------------------*/

const accordionBox = () => {
  const accordions = document.querySelectorAll('.js-accordion');
  if (!accordions.length) return;

  accordions.forEach(pd => {
    const btn = pd.querySelector('[data-acc-trigger]');
    const box = pd.querySelector('[data-acc-body]');
    let activeAction = true;
    btn.addEventListener('click', (e) => {
      pd.classList.toggle('is-open');
    });
  });
}

/*---------------------------------------------------------------------------------
  selectbox placeholder
---------------------------------------------------------------------------------*/

const selectBoxPlaceholder = () => {
  const selectBoxes = document.querySelectorAll('select');
  if (!selectBoxes.length) return;

  selectBoxes.forEach((select) => {
    select.addEventListener("change", function () {
      this.classList.add('is-selected');
      let placeholder = this.querySelector('._placeholder');
      if (placeholder) {
        let span = document.createElement('span');
        span.classList.add('selector-placeholder-hide');
        placeholder.parentNode.insertBefore(span, placeholder);
        span.appendChild(placeholder);
      }
    });
  });
}


/*---------------------------------------------------------------------------------
  幅固定のスライダー
---------------------------------------------------------------------------------*/
const fixWidthSlide = () => {
  const slides = document.querySelectorAll('.js-fw-slide');
  if (!slides.length) return;

  slides.forEach(function(slide) {
    const itemWidth = slide.getAttribute('data-item-width') || '320px';
    const bp = Number(String(itemWidth).replace('px', '') * 1.7);
    const staticBpRaw = slide.getAttribute('data-no-slider-below');
    const staticBp = staticBpRaw ? Number(String(staticBpRaw).replace('px', '')) : null;

    let arrows;
    if(slide.querySelector('.fw-slide__mo_arrows')) {
      arrows = `,"arrows":"true"`;
    } else {
      arrows = ``;
    }

    const moOption = `{"breakpoints":{"${bp}":{"fixedWidth":false,"perPage":1,"focus":"center","gap":"10px"${arrows}}}}`;

    let autoPlayVal = true;
    let intervalVal = 4000;
    let speedVal = 500;
    let rewindVal = true;

    if(slide.dataset.autoplay === 'false') {
      autoPlayVal = false;
      rewindVal = false;
    }

    if(slide.dataset.iv) {
      intervalVal = slide.dataset.iv;
    }

    if(slide.dataset.speed) {
      speedVal = slide.dataset.speed;
    }

    slide.setAttribute('data-splide', moOption);

    const mountSplide = () => {
      const splide = new Splide( slide, {
        arrows: false,
        autoplay: autoPlayVal,
        interval: intervalVal,
        speed: speedVal,
        rewind: rewindVal,
        updateOnMove: true,
        fixedWidth: itemWidth,
        gap: '20px',
        pagination: false,
        padding: false
      });
      splide.mount();
      return splide;
    };

    if (staticBp != null) {
      // data-no-slider-below 指定時: 指定幅以下ではスライダーにせず縦並び表示
      const mqlStatic = window.matchMedia(`(max-width:${staticBp}px)`);
      let splideInstance = null;

      const listenerStatic = (event) => {
        if (event.matches) {
          if (splideInstance) {
            splideInstance.destroy();
            splideInstance = null;
          }
          slide.classList.add('is-static-stack');
        } else {
          slide.classList.remove('is-static-stack');
          if (!splideInstance) {
            splideInstance = mountSplide();
          }
        }
      };

      mqlStatic.addEventListener('change', listenerStatic);
      if (mqlStatic.matches) {
        slide.classList.add('is-static-stack');
      } else {
        splideInstance = mountSplide();
      }
      return;
    }

    const mql = window.matchMedia(`(max-width:${bp}px)`);
    const splide = mountSplide();

    const listener = (event) => {
      if (event.matches) {
        slide.classList.add('is-fw-width');
      } else {
        slide.classList.remove('is-fw-width');
      }
    };

    mql.addEventListener('change', listener);
    listener(mql);
  });
}

/*---------------------------------------------------------------------------------
  お客様からの評価スライダー
---------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-customer-voice-slider').forEach(slider => {
    const hint = slider.querySelector('.swipe-hint');
    if (!hint) return;

    let isHintVisible = false;

    // Splide初期化
    const splide = new Splide(slider, {
      type: 'slide',
      arrows: false,
      pagination: false,
      drag: 'free',
      padding: { left: '50px', right: '50px' },
      gap: 16,
      grid: {
        rows: 2,
        cols: 3,
        gap: { row: '18px', col: '16px' },
      },
      breakpoints: {
        1150: { grid: { rows: 2, cols: 2 } },
        810: {
          padding: { left: '63.5px', right: '63.5px' },
          grid: { rows: 2, cols: 1, gap: { row: '20px', col: '10px' } },
          gap: 10,
        },
      },
    });

    // ドラッグ時にヒントを非表示
    splide.on('drag', () => {
      if (!isHintVisible) return;
      hint.classList.remove('is-visible');
      hint.classList.add('is-hidden');
      isHintVisible = false;
    });

    splide.mount(window.splide.Extensions);

    // 行ごとにカードの高さを揃える
    const equalizeCardHeights = () => {
      const cards = Array.from(slider.querySelectorAll('.voice-card'));
      const cols = splide.options.grid.cols;

      for (let i = 0; i < cards.length; i += cols) {
        const rowCards = cards.slice(i, i + cols);
        let maxHeight = 0;

        // 高さリセットして scrollHeight を取得
        rowCards.forEach(card => {
          card.style.height = 'auto';
          const h = card.scrollHeight;
          if (h > maxHeight) maxHeight = h;
        });

        // 高さを揃える
        rowCards.forEach(card => (card.style.height = maxHeight + 'px'));
      }
    };

    equalizeCardHeights();

    window.addEventListener('resize', equalizeCardHeights);

    slider.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', equalizeCardHeights);
    });

    // ResizeObserverで動的テキストにも対応
    const observerResize = new ResizeObserver(equalizeCardHeights);
    slider.querySelectorAll('.voice-card').forEach(card => observerResize.observe(card));

    // スワイプヒント表示
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!isHintVisible) {
              hint.classList.add('is-visible');
              hint.classList.remove('is-hidden');
              isHintVisible = true;
            }
          } else {
            hint.classList.remove('is-visible');
            hint.classList.remove('is-hidden');
            isHintVisible = false;
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(slider);
  });
});

/*---------------------------------------------------------------------------------
  資料サンプルのスワイプヒント
---------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.form-card__sample-images').forEach((container) => {
    const hint = container.querySelector('.swipe-hint');
    if (!hint) return;

    const updateHint = () => {
      const hasHorizontalOverflow = container.scrollWidth - container.clientWidth > 1;
      const hasScrolled = container.scrollLeft > 8;

      if (!hasHorizontalOverflow) {
        hint.classList.remove('is-visible', 'is-hidden');
        return;
      }

      if (hasScrolled) {
        hint.classList.remove('is-visible');
        hint.classList.add('is-hidden');
        return;
      }

      hint.classList.add('is-visible');
      hint.classList.remove('is-hidden');
    };

    container.addEventListener('scroll', updateHint, { passive: true });
    window.addEventListener('resize', updateHint);
    updateHint();
  });
});


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------
  youtube埋め込みモーダル
---------------------------------------------------------------------------------*/
const youtubeLazyModal = () => {
  const embedVideos = document.querySelectorAll('.js-modal-video');
  if (!embedVideos.length) return;

  embedVideos.forEach((video) => {
    const iframe = video.querySelector('iframe');
    if (!iframe) return;

    const videoThumb = video.querySelector('.js-modal-video__thumb');
    const videoBody = video.querySelector('.js-modal-video__body');
    const url = iframe.getAttribute('data-src');
    const thumb = iframe.getAttribute('data-thumb');
    if (!url) return;

    const title = iframe.getAttribute('title');
    const idMatch = url.match(/[\/?=]([a-zA-Z0-9_-]{11})[&\?]?/);
    if (!idMatch) return;
    const id = idMatch[1];
    
    document.body.appendChild(videoBody.parentElement);

    let thumbCode = `
      <img src="${thumb || `https://img.youtube.com/vi/${id}/maxresdefault.jpg`}" alt="${title}" width="1280" height="720" />
      <div class="play-btn"></div>
    `;
    videoThumb.insertAdjacentHTML('afterbegin', thumbCode);
    iframe.remove();

    videoThumb.addEventListener('click', function () {
      if (!videoBody.querySelector('.loded-video')) {
        videoBody.innerHTML = `
        <div class="loded-video">
          <iframe
            src="https://www.youtube.com/embed/${id}?enablejsapi=1"
            title="${title}"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
        `;
      } else {
        return;
      }
    });

    const modalRoot = videoBody.parentElement;
    const modalClose = modalRoot.querySelectorAll('[data-modal-close]');
    modalClose.forEach(btn => {
      btn.addEventListener('click', () => {
        videoBody.innerHTML = '';
      });
    });
  });
}


/*---------------------------------------------------------------------------------
  ツールチップ
---------------------------------------------------------------------------------*/

const toolTips = () => {
  const groups = document.querySelectorAll('.tooltip-group');
  if (!groups.length) return;

  const mq = window.matchMedia('(hover: hover) and (pointer: fine)');

  let isHoverEnabled = true;

  const closeAll = () => {
    document.querySelectorAll('.tooltip.is-tap')
      .forEach(t => t.classList.remove('is-tap'));
  };
  
  const fitTooltipWidth = (tooltip) => {
    const margin = 40; // 画面端余白

    tooltip.style.maxWidth = '';

    const rect = tooltip.getBoundingClientRect();

    const spaceLeft = rect.left;
    const spaceRight = window.innerWidth - rect.right;

    // 両サイドの余白ベースで最大幅決める
    const maxWidth = Math.min(
      rect.width,
      spaceLeft + rect.width - margin,
      spaceRight + rect.width - margin
    );

    tooltip.style.maxWidth = `${maxWidth}px`;
  };

  groups.forEach(group => {
    const tooltip = group.querySelector('.tooltip');
    const closeBtn = group.querySelector('.tooltip-close');
    const area = group.closest('.js-tooltip-area');

    if (!tooltip || !area) return;

    // PC（hover）
    area.addEventListener('mouseenter', () => {
      if (!mq.matches || !isHoverEnabled) return;

      closeAll();
      tooltip.classList.add('is-tap');
    });

    area.addEventListener('mouseleave', () => {
      if (!mq.matches || !isHoverEnabled) return;

      tooltip.classList.remove('is-tap');
    });

    // SP（tap）
    area.addEventListener('click', (e) => {
      if (mq.matches) return;

      if (e.target.closest('.tooltip')) return;
      if (e.target.closest('a')) return;

      e.preventDefault();
      e.stopPropagation();

      const isOpen = tooltip.classList.contains('is-tap');

      closeAll();

      if (!isOpen) {
        tooltip.classList.add('is-tap');

        requestAnimationFrame(() => {
          fitTooltipWidth(tooltip);
        });
      }
    });

    tooltip.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    closeBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      tooltip.classList.remove('is-tap');
    });
  });

  // SPだけ外クリックで閉じる
  document.addEventListener('click', (e) => {
    if (mq.matches) return;

    document.querySelectorAll('.tooltip.is-tap').forEach(tooltip => {
      const group = tooltip.closest('.tooltip-group');
      if (group && !group.contains(e.target)) {
        tooltip.classList.remove('is-tap');
      }
    });
  });

  window.addEventListener('focus', () => {
    isHoverEnabled = true;
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.tooltip.is-tap').forEach(t => {
      fitTooltipWidth(t);
    });
  });
};

/*---------------------------------------------------------------------------------
  寺院詳細ページ　画像スライダー
---------------------------------------------------------------------------------*/

const tmpDtlImageSlide = () => {

  const dtlSlide = document.querySelector('.detail-slide');
  if (!dtlSlide) return;

  let controller = new AbortController();

  const mainSlide = dtlSlide.querySelector('.main-slide');
  const slideNavi = dtlSlide.querySelector('.slide-navi');

  const container = document.querySelector('.detail-slide .thumbnails'); // wrapするの要素を取得
  const siteFrameMain = document.querySelector('.site-wrapper main');
  const getSlides = () => mainSlide.querySelectorAll('.splide__slide');

  const ctaSlide = mainSlide.querySelector('.main-slide__cta');
  const ctaSlideList = ctaSlide ? ctaSlide.parentElement : null;

  const galleryModal = new Modal();
  let isGalleryModalEnabled = false;
  let isMobileLayout = false;

  document.querySelectorAll('.detail-slide-modal__movie').forEach((wrap) => {
    const thumbBtn = wrap.querySelector('.detail-slide-modal__movie-thumb');
    const movieId = wrap.dataset.movieId;
    if (!thumbBtn || !movieId) return;

    thumbBtn.addEventListener('click', () => {
      if (wrap.querySelector('iframe')) return;
      const iframe = document.createElement('iframe');
      iframe.className = 'fit-cover';
      iframe.src = `https://www.youtube.com/embed/${movieId}?autoplay=1`;
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.setAttribute('allowfullscreen', '');
      wrap.appendChild(iframe);
    });
  });

  document.querySelectorAll('.detail-slide-modal [data-modal-close]').forEach((closeEl) => {
    closeEl.addEventListener('click', () => {
      document.querySelectorAll('.detail-slide-modal__movie iframe').forEach((iframe) => iframe.remove());
    });
  });

  document.querySelectorAll('.detail-slide-modal .form-cta a').forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href') || '';
      galleryModal.closeModal();

      if (href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 500);
        }
      }
    });
  });

  const openGalleryModal = (index) => {
    if (!isGalleryModalEnabled) return;

    const target = document.querySelector(`.detail-slide-modal [data-slide-index="${index}"]`);
    if (!target) return;

    const scrollToTarget = () => target.scrollIntoView({ block: 'start' });
    galleryModal.openModalById('detail-slide-gallery');
    scrollToTarget();

    setTimeout(() => {
      scrollToTarget();

      document.querySelectorAll('.detail-slide-modal__list img').forEach((img) => {
        const figure = img.closest('[data-slide-index]');
        if (!figure || Number(figure.dataset.slideIndex) > index || img.complete) return;
        img.addEventListener('load', scrollToTarget, { once: true });
      });
    }, 450);
  };


  const buildThumbContent = (item, slide) => {
    // 動画
    if (slide.dataset.type === 'movie') {
      const movieId = slide.dataset.movieId;
      if (movieId) {
        const img = document.createElement('img');
        img.src = `https://img.youtube.com/vi/${movieId}/mqdefault.jpg`;
        item.appendChild(img);
      }

    // 画像
    } else {
      const img = slide.querySelector('img');
      if (img) {
        item.appendChild(img.cloneNode(true));
      }
    }
  };

  const createThumbList = () => {
    const imagesPerList = 12;
    let wrap;
    let visibleIndex = 0;

    getSlides().forEach((slide) => {
      if (slide.dataset.type === 'cta') return;

      if (visibleIndex % imagesPerList === 0) {
        wrap = document.createElement('div');
        wrap.classList.add('splide__slide','wrap');
        container.appendChild(wrap);
      }

      const item = document.createElement('figure');
      item.classList.add('thumbnail');
      buildThumbContent(item, slide);

      wrap.appendChild(item);
      visibleIndex++;
    });
  }

  const createMobileThumbList = () => {
    getSlides().forEach((slide) => {
      if (slide.dataset.type === 'cta') return;

      const item = document.createElement('figure');
      item.classList.add('splide__slide','thumbnail');
      buildThumbContent(item, slide);

      container.appendChild(item);
    });
  }

  const delThumbList = () => {
    container.innerHTML = '';
  }

  const thumbClickInterloc = (navSplide) => {
    let current;

    const activateThumbnail = (index) => {
      const thumbnails = document.querySelectorAll('.slide-navi .thumbnail:not(.splide__slide--clone)');
      const thumbnail = thumbnails[index];
      if (!thumbnail) return;
      if (current) {
        current.classList.remove('is-active');
      }
      thumbnail.classList.add('is-active');
      current = thumbnail;
    };

    if (navSplide) {
      navSplide.off('click').on('click', (Slide) => {
        main.go(Slide.isClone ? Slide.slideIndex : Slide.index);
      });
    } else {
      const thumbnails = document.querySelectorAll('.slide-navi .thumbnail:not(.splide__slide--clone)');
      for (var i = 0; i < thumbnails.length; i++ ) {
        initThumbnail( thumbnails[ i ], i );
      }

      function initThumbnail(thumbnail, index) {
        thumbnail.addEventListener('click', function () {
          main.go(index);
        }, { signal: controller.signal });
      }
    }

    main.on('mounted move', function () {
      activateThumbnail(main.index);
      if (navSplide) {
        navSplide.go(main.index);
      }
    });
  }

  const main = new Splide( mainSlide, {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: false,
  });

  const slidenavi = new Splide( slideNavi, {
    rewind: true,
    pagination: false,
    gap: '1rem'
  });

  const slidenaviMo = new Splide( slideNavi, {
    type: 'loop',
    rewind: true,
    pagination: false,
    arrows: false,
    isNavigation: true,
    perPage: 3,
    perMove: 1,
    padding: '10%',
    gap: '10px'
  });

  const slidenaviRow = new Splide( slideNavi, {
    type: 'loop',
    rewind: true,
    pagination: false,
    arrows: false,
    perPage: 3,
    perMove: 1,
    padding: '10%',
    gap: '10px',
    focus: 'center',
  });

  mainSlide.addEventListener('click', (e) => {
    if (!isGalleryModalEnabled) return;
    if (!e.target.closest('.splide__slide.is-active')) return;

    openGalleryModal(main.index);
  });

  const prevBtn = dtlSlide.querySelector('.js-main-slide-prev');
  const nextBtn = dtlSlide.querySelector('.js-main-slide-next');
  prevBtn?.addEventListener('click', () => main.go('<'));
  nextBtn?.addEventListener('click', () => main.go('>'));

  let lastWidth = siteFrameMain.offsetWidth; // 初期幅を記録
  let lastHeight = siteFrameMain.offsetHeight; // 初期幅を記録
  let isInitialized = false;
  let stdHeight;

  let slideHeight = dtlSlide.offsetHeight;

  const mountFunc = (width) => {
    isGalleryModalEnabled = width <= 560;
    isMobileLayout = width <= 800;

    if (ctaSlide) {
      if (isGalleryModalEnabled) {
        ctaSlide.remove();
      } else if (!ctaSlide.parentElement && ctaSlideList) {
        ctaSlideList.appendChild(ctaSlide);
      }
    }

    setTimeout(() => {
      stdHeight = mainSlide.querySelector('img').offsetHeight;
      dtlSlide.style.setProperty('--_msi-h', stdHeight + 'px');
    }, '50');

    if (isGalleryModalEnabled) {
      delThumbList();
      createMobileThumbList();
      main.sync(slidenaviMo);
      main.mount();
      slidenaviMo.mount();
      slidenaviMo.off('click').on('click', (Slide) => {
        openGalleryModal(Slide.isClone ? Slide.slideIndex : Slide.index);
      });
    } else if (isMobileLayout) {
      delThumbList();
      createMobileThumbList();
      slidenaviRow.mount();
      thumbClickInterloc(slidenaviRow);
      main.mount();
    } else {
      delThumbList();
      createThumbList();
      thumbClickInterloc();
      main.mount();
      slidenavi.mount();

      const naviArrowEl = dtlSlide.querySelector('.slide-navi__arrow');
      if (naviArrowEl) {
        const wrapCount = container.querySelectorAll('.wrap').length;
        naviArrowEl.classList.toggle('is-arrows-hidden', wrapCount <= 1);
      }
    }
  };

  //初回実行 (ページロード時にも処理を適用)
  mountFunc(lastWidth);

  const resizeHandler = _debounce((width) => {
    mountFunc(width);
  }, 300);

  const resizeObserver = new ResizeObserver(([entry]) => {
    if (!isInitialized) {
      isInitialized = true; // 初回はスキップ
      return;
    }

    const { width, height } = entry.contentRect;

    if (width !== lastWidth) {
      controller.abort();
      controller = new AbortController();
      main.destroy();
      slidenavi.destroy();
      slidenaviMo.destroy();
      slidenaviRow.destroy();
      resizeHandler(width);
    }

    lastWidth = width;
    lastHeight = height;
    slideHeight = dtlSlide.offsetHeight;
  });

  resizeObserver.observe(siteFrameMain);
}


/*---------------------------------------------------------------------------------
  資料の一括請求ボタン  s-recsInfos
---------------------------------------------------------------------------------*/


const recsInfos = () => {
  const btns = document.querySelectorAll('.js-recsInfos');
  const countEls = document.querySelectorAll('.js-check-count');
  const clearBtn = document.querySelector('.js-clear-selection');
  const primaryCheckboxes = document.querySelectorAll('.temple-card input[name="temple_id[]"]');
  const allCheckboxes = document.querySelectorAll('.temple-card input[type="checkbox"]');
  const masterCheck = document.querySelector('.master-check');

  if (!btns.length) return;

  let checkedIds = [];

  const getCardCheckboxes = (card) => card.querySelectorAll('input[type="checkbox"]');

  const initUI = () => {
    allCheckboxes.forEach(cb => cb.classList.add('is-visible'));
    countEls.forEach(el => el.classList.add('is-visible'));
    updateUI();
  };

  const updateUI = () => {
    btns.forEach(btn => btn.disabled = checkedIds.length === 0);
    countEls.forEach(el => {
      el.textContent = checkedIds.length;
    });

    primaryCheckboxes.forEach((primaryCb) => {
      const card = primaryCb.closest('.temple-card');
      if (!card) return;
      const isChecked = checkedIds.includes(primaryCb.value);
      getCardCheckboxes(card).forEach((cb) => {
        cb.checked = isChecked;
      });
    });

    if (masterCheck) {
      masterCheck.checked = primaryCheckboxes.length > 0 && checkedIds.length === primaryCheckboxes.length;
    }
  };

  allCheckboxes.forEach((cb) => {
    cb.addEventListener('change', () => {
      const card = cb.closest('.temple-card');
      if (!card) return;
      const primaryCb = card.querySelector('input[name="temple_id[]"]');
      if (!primaryCb) return;
      const id = primaryCb.value;
      if (cb.checked) {
        if (!checkedIds.includes(id)) checkedIds.push(id);
      } else {
        checkedIds = checkedIds.filter((v) => v !== id);
      }
      updateUI();
    });
  });

  document.querySelectorAll('.js-temple-bulk-request-btn').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const card = btn.closest('.temple-card');
      if (!card) return;
      const primaryCb = card.querySelector('input[name="temple_id[]"]');
      if (!primaryCb) return;
      primaryCb.checked = !primaryCb.checked;
      primaryCb.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  if (masterCheck) {
    masterCheck.addEventListener('change', () => {
      if (masterCheck.checked) {
        primaryCheckboxes.forEach((cb) => {
          if (!checkedIds.includes(cb.value)) checkedIds.push(cb.value);
        });
      } else {
        checkedIds = [];
      }
      updateUI();
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      checkedIds = [];
      updateUI();
    });
  }

  initUI();
};

/*---------------------------------------------------------------------------------
  フォームの個人情報の取扱いに同意 チェックボックス
---------------------------------------------------------------------------------*/

const privacyAgree = () => {
  const privCheck = document.querySelector('#js-priv-check');
  if (!privCheck) return;

  const privSubmit = document.querySelectorAll('.js-priv-submit');

  privCheck.addEventListener('change', function () {
    if (this.checked) {
      privSubmit.forEach(function (element) {
        element.disabled = false;
      });
    } else {
      privSubmit.forEach(function (element) {
        element.disabled = true;
      });
    }
  });
}


/*---------------------------------------------------------------------------------
  table of contents - 記事ページ目次を作成
---------------------------------------------------------------------------------*/

const tableOfContents = () => {
  const toc = document.querySelector('.js-toc');
  if (!toc) return;
  const entryBody = document.querySelector('.entry-body');
  // const heads = entryBody.querySelectorAll('h2, h3');
  const heads = document.querySelectorAll('.entry-body > h2,.entry-body > h3, .entry-body > * > h2, .entry-body > * > h3');

  if (!heads.length) {
    toc.style.display = 'none';
    return;
  }

  let contents = '';
  heads.forEach((head, i) => {
    let className = '';
    switch(head.localName) {
      case "h2":
        className = `hlv-2`;
        break;
      case "h3":
        className = `hlv-3`;
        break;
    }

    // 記事中のヘディングタグに ID を設定
    const headingId = `head${i + 1}`;
    head.id = headingId;

    // 目次リンクの作成
    contents += `<li class="toc-list__item ${className}"><a href="#heading${i + 1}">${head.textContent}</a></li>`;
    head.innerHTML += `<a id="heading${i + 1}"></a>`;
  })
  document.querySelector('.toc-content').innerHTML += `<ol class='toc-list'>${contents}</ol>`;
}


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/
const condChangeBtn = () => {
  const openBtn = document.querySelector('.cond-chg-btn.js-condChange');
  if (!openBtn) return;

  const panel = document.querySelector('.results-search');
  if (!panel) return;

  const closeBtn = panel.querySelector('.ccb-close');
  if (!closeBtn) return;

  const mql = window.matchMedia(mq_sds);

  const panelOpen = () => panel.classList.add('is-open');
  const panelClose = () => panel.classList.remove('is-open');

  openBtn.addEventListener('click', () => panelOpen());
  closeBtn.addEventListener('click', () => panelClose());

  mql.addEventListener('change', (event) => { if (!event.matches) panelClose(); });
  if (!mql.matches) panelClose();
};

document.addEventListener('DOMContentLoaded', () => {
  const modal = new Modal();
  condChangeBtn();

  // 通常の「お墓を探す」ボタン
  const mainSearchBtns = document.querySelectorAll('.js-condChange:not(.js-gnavi):not(.cond-chg-btn)');
  mainSearchBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.openModalById('area-prefectures');
    });
  });
  
  // グローバルナビ用ボタン（SPのみ）
  const gnaviLis = document.querySelectorAll('.js-gnavi.js-condChange');
  gnaviLis.forEach(gnaviLi => {
    gnaviLi.addEventListener('click', (e) => {
      if (mq_ns.match) {
        e.preventDefault();
        modal.openModalById('area-prefectures');
      }
    }, { capture: true });
  });

  // 条件変更ボタン（都道府県モーダルは開かない）
  const condBtns = document.querySelectorAll('.cond-chg-btn.js-condChange');
  condBtns.forEach(condBtn => {
    condBtn.addEventListener('click', () => {
      const resultsPanel = document.querySelector('.results-search');
      if (resultsPanel) {
        resultsPanel.classList.add('is-open');
      }
    });
  });
});



/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const checkboxBind = (rangeSelector, displaySelector, btnSelector) => {
  const range = document.querySelector(rangeSelector);
  const display = document.querySelector(displaySelector);

  if (!range || !display) return;

  const btnSel = btnSelector || '.label-btn';

  const checkboxes = range.querySelectorAll(`${btnSel} input[type="checkbox"]`);

  const applySelections = () => {
    const checkedInputs = Array.from(checkboxes).filter(input => input.checked);

    display.innerHTML = checkedInputs
      .map(input => {
        const labelBtn = input.closest(btnSel);
        const textElement = labelBtn.querySelector('._text');
        return textElement ? `<span>${textElement.textContent.trim()}</span>` : '';
      })
      .join('');

    display.parentNode
      .querySelectorAll('input[type="hidden"]')
      .forEach(el => el.remove());

    const hiddenHTML = checkedInputs
      .map(input => `<input type="hidden" name="${input.name}" value="${input.value}">`)
      .join('');
    display.insertAdjacentHTML('afterend', hiddenHTML);
  };

  const submitBtn = range.querySelector('[data-apply-conditions]');

  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      applySelections();
      const closeBtn = range.querySelector('[data-modal-close]');
      closeBtn?.click();
    });
  }
};


const radioBind = (rangeSelector, displaySelector, btnSelector) => {
  const range = document.querySelector(rangeSelector);
  const display = document.querySelector(displaySelector);

  if (!range || !display) return;

  const btnSel = btnSelector || '.label-btn';

  const radios = range.querySelectorAll(`${btnSel} input[type="radio"]`);

  const updateDisplay = () => {
    const checkedRadio = Array.from(radios).find(input => input.checked);

    if (checkedRadio) {
      const label = checkedRadio.closest(btnSel);
      const textEl = label?.querySelector('._text');
      display.innerHTML = textEl ? `<span>${textEl.textContent.trim()}</span>` : '';
    } else {
      display.innerHTML = '';
    }
  };

  radios.forEach(rb => rb.addEventListener('change', updateDisplay));
  // updateDisplay();
};

/*---------------------------------------------------------------------------------
  ダウンロードサンプル画像モーダル
---------------------------------------------------------------------------------*/
const downloadSampleModal = () => {
  const modalId = 'download-sample';
  const modal = document.querySelector(`.js-modal[data-modal-id="${modalId}"]`);
  const modalImage = modal?.querySelector('[data-download-modal-image]');
  const triggerButtons = document.querySelectorAll(`.form-card__sample-images [data-modal-open][data-modal-id="${modalId}"]`);

  if (!modal || !modalImage || !triggerButtons.length) return;

  triggerButtons.forEach((button) => {
    const image = button.querySelector('img');
    if (!image) return;

    button.addEventListener('click', () => {
      modalImage.src = image.src;
      modalImage.alt = image.alt || '';
    });
  });

  modal.querySelectorAll('[data-modal-close]').forEach((closeElm) => {
    closeElm.addEventListener('click', () => {
      modalImage.src = '';
      modalImage.alt = '';
    });
  });
}


/*---------------------------------------------------------------------------------
郵便番号から緯度経度を取得
---------------------------------------------------------------------------------*/
const GEO_API_URL = "https://geoapi.heartrails.com/api/json";

/**
 * 郵便番号から住所と緯度経度を取得する
 */
const resolvePostal = zipcode => {
  return fetch(`${GEO_API_URL}?method=searchByPostal&postal=${zipcode}`)
    .then(res => res.json())
    .then(data => {
      const location = data?.response?.location?.[0];
      if (!location) return null;

      return {
        address: `${location.prefecture}${location.city}`,
        lat: parseFloat(location.y),
        lng: parseFloat(location.x)
      };
    })
    .catch(() => null);
};

/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function(){
  subNaiHandler()
  mobileGnavi()
  fixWidthSlide()
  youtubeLazyModal()
  toolTips()
  tmpDtlImageSlide()
  recsInfos()
  privacyAgree()
  tableOfContents()
  condChangeBtn()
  const modals = new Modal()
  downloadSampleModal()
  templePriceModals()
  selectBoxPlaceholder()
  accordionBox()
  zipAutoFill()
  templeDistance()
  diagnosticStepControl();
  documentRequestStepControl();
  ctaComponent();
  prefCityLinkage();
  paginationUrlCustom();
  downloadCityFilter()

  radioBind('.area-pref-modal','.area-pref-value','.pref-btn')
  checkboxBind('.area-muni-modal','.area-muni-value','.condition-item')
  checkboxBind('.conditions-modal','.conditions-value','.condition-item')
  prefMuniNavBind()
  hoistPrefMuniModalsToBody()
})

// 都道府県別 市区町村モーダルは search-area.php 内（= <main> の中）で出力される。
// <main> には `container: frame-main / inline-size` が指定されており、
// `contain: layout` により stacking context が生成され、header 等の外側要素より
// 下に描画されてしまうため、DOM上 <body> 直下に移動して回避する。
const hoistPrefMuniModalsToBody = () => {
  document.querySelectorAll('.js-modal[data-modal-id^="area-pref-"]').forEach((modal) => {
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  });
};

const prefMuniNavBind = () => {
  document.querySelectorAll('[data-pref-apply]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const baseUrl = btn.getAttribute('data-pref-url');
      if (!baseUrl) return;

      const modal = btn.closest('.js-modal');
      if (!modal) {
        window.location.href = baseUrl;
        return;
      }

      const params = new URLSearchParams();
      modal.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        params.append(input.name, input.value);
      });
      const query = params.toString();
      window.location.href = query ? `${baseUrl}?${query}` : baseUrl;
    });
  });
};


/**
 * フォームバリデーション
 * ステップ形式フォーム（documentRequestStepControl）の各ステップ検証からも共用する
 */
const validateStepFields = ($container) => {
  let isSubmitReady = true
  let firstErrorElement = null
  $container.find('[data-required-error]').hide()
  $container.find('[data-kana-error]').hide()
  $container.find('[data-email-error]').hide()
  $container.find('[data-tel-error]').hide()
  $container.find('[data-validation]').map(function () {
    const inputName = $(this).data('validation-name') === undefined ? $(this).attr('name') : $(this).data('validation-name')
    const validationTypeLists = $(this).data('validation').split(',')
    const isRequired = !!validationTypeLists.find(type => type === 'required')
    const isSpaceZen = !!validationTypeLists.find(type => type === 'space-zen')
    const isKana = !!validationTypeLists.find(type => type === 'kana')
    const isEmail = !!validationTypeLists.find(type => type === 'email')
    const isTel = !!validationTypeLists.find(type => type === 'tel')
    const isHasBone = !!validationTypeLists.find(type => type === 'has_bone')
    if (isRequired) {
      if ($(this).data('validation-name') === undefined) {
        if (!$(this).val()) {
          isSubmitReady = false
          const errorElement = $container.find(`[data-required-error="${inputName}"]`)
          errorElement.show()
          if (!firstErrorElement) {
            firstErrorElement = $(this)
          }
        }
      } else {
        if (!$(this).find(`[name^="${inputName}"]:checked`).length) {
          isSubmitReady = false
          const errorElement = $container.find(`[data-required-error="${inputName}"]`)
          errorElement.show()
          if (!firstErrorElement) {
            firstErrorElement = errorElement.length ? errorElement : $(this)
          }
        }
      }
    }
    if (isSpaceZen) {
      const errorElement = $container.find(`[data-space-zen-error="${inputName}"]`);
      if (/[\s　]/.test($(this).val())) {
        isSubmitReady = false;
        errorElement.show();
        if (!firstErrorElement) {
          firstErrorElement = $(this)
        }
      } else {
        errorElement.hide();
      }
    }
    if (isKana) {
      if ($(this).val()) {
        if (!$(this).val().match(/^[ァ-ヶー]+$/)) {
          isSubmitReady = false
          const errorElement = $container.find(`[data-kana-error="${inputName}"]`)
          errorElement.show()
          if (!firstErrorElement) {
            firstErrorElement = $(this)
          }
        }
      }
    }
    if (isEmail) {
      if ($(this).val()) {
        if (/^\s|^　|\s$|　$|\s|　/.test($(this).val()) || !$(this).val().match(/.+@.+\..+/)) {
          isSubmitReady = false
          const errorElement = $container.find(`[data-email-error="${inputName}"]`)
          errorElement.show()
          if (!firstErrorElement) {
            firstErrorElement = $(this)
          }
        }
      }
    }
    if (isTel) {
      if ($(this).val()) {
        if (!$(this).val().match(/^0\d{9,10}$/)) {
          isSubmitReady = false
          const errorElement = $container.find(`[data-tel-error="${inputName}"]`)
          errorElement.show()
          if (!firstErrorElement) {
            firstErrorElement = $(this)
          }
        }
      }
    }
    if (isHasBone) {
      const hasBoneField = $container.find('input[name="has_bone"]');
      if (hasBoneField.length > 0) {
        const hasBone = hasBoneField.filter(':checked').val();
        if (!hasBone) {
          isSubmitReady = false;
          const errorElement = $container.find(`[data-required-error="has_bone"]`)
          errorElement.show();
          if (!firstErrorElement) {
            firstErrorElement = hasBoneField.first()
          }
        }
      }
    }
  })
  return { isValid: isSubmitReady, firstErrorElement }
}

/**
 * バリデーションエラー時、最初のエラー項目までスクロール＆フォーカスする
 */
const focusFirstError = ($container, firstErrorElement) => {
  if (!firstErrorElement || !firstErrorElement.length) return
  let scrollTarget = null
  if (firstErrorElement.is('[data-required-error], [data-kana-error], [data-email-error], [data-tel-error]')) {
    scrollTarget = firstErrorElement.closest('.form-field')
  } else if (firstErrorElement.is('input[type="hidden"]')) {
    const inputName = firstErrorElement.data('validation-name') || firstErrorElement.attr('name')
    const errorElement = $container.find(`[data-required-error="${inputName}"]`)
    if (errorElement.length) {
      scrollTarget = errorElement.closest('.form-field')
    } else {
      scrollTarget = firstErrorElement.closest('.form-field')
    }
  } else {
    scrollTarget = firstErrorElement.closest('.form-field').length
      ? firstErrorElement.closest('.form-field')
      : firstErrorElement
  }

  if (scrollTarget && scrollTarget.length) {
    const offsetTop = scrollTarget.offset().top - 180
    $('html, body').animate({
      scrollTop: offsetTop
    }, 400)
    if (firstErrorElement.is('input:not([type="hidden"]), select, textarea')) {
      firstErrorElement.focus()
    }
  }
}


$(function () {
  /**
   * 同意ボタンの非活性化
   */
  const disabledCheckElement = $('[data-submit-disabled-check-trigger]')
  const disabledSubmitElement = $('[data-submit-disabled]')
  if (disabledCheckElement.length && disabledSubmitElement.length) {
    disabledCheckElement.on('change', function () {
      if ($(this).prop('checked')) {
        disabledSubmitElement.attr('data-submit-disabled', '')
        disabledSubmitElement.find('input, button').prop('disabled', false)
      } else {
        disabledSubmitElement.attr('data-submit-disabled', 'disabled')
        disabledSubmitElement.find('input, button').prop('disabled', true)
      }
    })
  }


  /**
   * Cookieからトラッキングパラメータを取得し、フォーム値に反映する
   */
  const trackingParams = {
    utm_campaign: null,
    utm_source: null,
    utm_medium: null,
    utm_content: null,
    utm_term: null,
    gclid: null,
    gad_source: null,
    gad_campaignid: null
  }
  const cookieLists = document.cookie
  if (cookieLists) {
    const cookies = cookieLists.split(';')
    cookies.forEach(function (cookieVal) {
      const vals = cookieVal.split('=')
      const cookieName = vals[0].replace(/ /, '')
      const cookieValue = vals[1]
      Object.keys(trackingParams).forEach(function (key) {
        if (key === cookieName) {
          trackingParams[key] = cookieValue
        }
      })
    })
  }
  Object.keys(trackingParams).forEach(function (key) {
    if (trackingParams[key]) {
      $(`[name="${key}"]`).val(trackingParams[key])
    }
  })


  /**
   * submit前にpayloadの調整をする
   * トリガーはtype="button"にすること
   */
  $('[data-change-param]').on('click', function () {
    if ($('input[data-checkbox="grave_type"]').length) {
      $('[name="grave_type"]').val('')
      if ($('input[data-checkbox="grave_type"]:checked').length) {
        $('[name="grave_type"]').val($('input[data-checkbox="grave_type"]:checked').map(function () {
          return $(this).val()
        })
          .get()
          .join(','))
      }
    }
    if ($('input[data-checkbox="temple"]').length) {
      $('[name="temple"]').val('')
      if ($('input[data-checkbox="temple"]:checked').length) {
        $('[name="temple"]').val($('input[data-checkbox="temple"]:checked').map(function () {
          return $(this).val()
        })
          .get()
          .join(','))
      }
    }
    $('[data-request-form]').submit()
  })


  /**
   * フォームバリデーション
   */
  $('form[data-request-form]').submit(function (e) {
    const _self = $(this)
    const { isValid, firstErrorElement } = validateStepFields(_self)
    if (!isValid) {
      focusFirstError(_self, firstErrorElement)
      return false
    }
    // 住所2送信前処理：住所1に表示済みの町域を「その他住所・番地」の先頭へ結合して送信専用hiddenにセット
    // 住所2の入力欄(#address)は手入力値のまま汚さず、送信専用hidden(#address-send)で送る（送信値は現行と同一）
    const addressTownField = _self.find('#address-town')
    const addressField = _self.find('#address')
    const addressSendField = _self.find('#address-send')
    if (addressField.length && addressSendField.length) {
      const town = addressTownField.length ? (addressTownField.val() || '') : ''
      addressSendField.val(town + (addressField.val() || ''))
      addressSendField.attr('name', 'address')
      addressField.removeAttr('name')
    }
    // 多重送信防止: バリデーション通過後にボタンを非活性化してローディング表示
    _self.find('[data-change-param]').prop('disabled', true)
    // オーバーレイを body に直接追加（親要素の overflow/transform の影響を回避）
    $('body').addClass('is-no-scroll').append(
      '<div class="form-loading-overlay is-active" id="js-form-loading" aria-hidden="false">' +
        '<div class="form-loading-overlay__inner">' +
          '<span class="form-loading-overlay__spinner" aria-hidden="true"></span>' +
          '<p class="form-loading-overlay__text">ただいま、送信中です</p>' +
        '</div>' +
      '</div>'
    )
  })

  /**
   * 必須項目：入力があったら赤背景用クラス(_required)を外す
   */
  $(document).on('input change', '[data-request-form] .form-field__input._required, [data-request-form] .form-field__select._required, [data-request-form] .form-choice__input._required', function () {
    const $el = $(this)
    const tagName = this.tagName.toLowerCase()
    const type = (this.type || '').toLowerCase()
    let hasValue = false
    if (type === 'checkbox' || type === 'radio') {
      if (type === 'radio') {
        hasValue = $el.closest('form').find(`input[name="${this.name}"]:checked`).length > 0
        const $group = $el.closest('form').find(`input[name="${this.name}"]`)
        if (hasValue) {
          $group.removeClass('_required')
        } else {
          $group.addClass('_required')
        }
      } else {
        hasValue = this.checked
        if (hasValue) $el.removeClass('_required')
        else $el.addClass('_required')
      }
    } else {
      hasValue = $el.val() != null && String($el.val()).trim() !== ''
      if (hasValue) {
        $el.removeClass('_required')
      } else {
        $el.addClass('_required')
      }
    }
  })

})


/**
 * 動的にpath切り替え処理
 */
const calenderRequestPath = document.querySelector('[data-form-path]');

if (calenderRequestPath) {
  const url = 'https://www2.eitaikuyou.net';
  const path = calenderRequestPath.dataset.formPath;
  const requestUrl = url + path;

  const calenderRequestButton = document.querySelector('[data-change-param]');
  if (calenderRequestButton) {
    calenderRequestButton.addEventListener('click', function(event) {
      if (calenderRequestPath.checkValidity()) {
        calenderRequestPath.action = requestUrl;
      } else {
        event.preventDefault();
        calenderRequestPath.reportValidity();
      }
    });
  }
}

/**
 * Cookieで引き継ぐ個人情報の項目名
 */
const FORM_COOKIE_FIELDS = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel', 'zipcode', 'prefecture', 'city', 'address_town', 'address'];

/**
 * フォーム入力値をCookieへ保存する
 */
function setFormCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}

/**
 * フォーム送信時にsuccesslocationに値を含める
 */
document.addEventListener('DOMContentLoaded', () => {
  FORM_COOKIE_FIELDS.forEach(fieldName => {
    const inputField = document.querySelector(`input[name="${fieldName}"]`);
    if (inputField) {
      inputField.addEventListener('input', (event) => {
        const fieldValue = event.target.value;
        setFormCookie(fieldName, fieldValue, 1);
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const path = window.location.pathname;
  if (path.startsWith('/document-request/complete')) {
    setFormData();
  }
  function setFormData() {
    function getCookie(name) {
      let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    const fields = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel'];
    fields.forEach(field => {
      const value = getCookie(field);
      if (value) document.querySelector(`input[name="${field}"]`).value = value;
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  function deleteCookie(name) {
    document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
  }
  function deleteFormCookies() {
    const fields = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel'];
    fields.forEach(field => {
      deleteCookie(field);
    });
  }
  const button = document.querySelector('.submit.calendar-submit[data-change-param]');
  if (button && window.location.pathname.endsWith('/document-request/complete')) {
    button.addEventListener('click', deleteFormCookies);
  }
});


/**
 * カレンダー表示
 */
$(document).ready(function() {
  const $tourDateDisplay = $("#tour_date_display");
  const $hiddenTourDate = $("#tour_date");
  const $datepickerContainer = $("#datepicker-container");

  // 3ヶ月後の末日を計算する関数
  const today = new Date();
  today.setHours(0, 0, 0, 0); // 時間をリセットして、日付のみで比較できるようにする
  function getLastDateOfThreeMonthsLater() {
    return new Date(today.getFullYear(), today.getMonth() + 4, 0);
  }
  const maxDate = getLastDateOfThreeMonthsLater();
  let holidaysData = {};

  // 日付と曜日を組み合わせたフォーマットを作成する関数（送信用）
  function createDateFormat(dateText){
    const date = new Date(dateText);
    const daysOfWeek = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];
    return dateText + ',' + daysOfWeek[date.getDay()];
  }

  // force_holidays + temple_week による休業日判定
  function isCheckHolidays(date){
    if (window.forceHolidaysData && window.forceHolidaysData.length > 0) {
      const dateStr = $.datepicker.formatDate('y-mm-dd', date);
      for (let i = 0; i < window.forceHolidaysData.length; i++) {
        const forceHoliday = window.forceHolidaysData[i];
        if (forceHoliday.date === dateStr) return !forceHoliday.is_working;
      }
    }
    if (window.templeWeekData && Object.keys(window.templeWeekData).length > 0) {
      const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      const dayKey = weekdays[date.getDay()];
      if(window.templeWeekData[dayKey]!==undefined) return !window.templeWeekData[dayKey];
    }
    return false;
  }

  // 選択可否と表示クラスを標準表示・6週表示で共通化
  function getDateState(date) {
    const ymd = $.datepicker.formatDate('yy-mm-dd', date);
    let isSelectable = true;
    const classNames = [];

    if (date < today) {
      classNames.push('past-date');
      isSelectable = false;
    } else if (isCheckHolidays(date)) {
      classNames.push('holidays');
      isSelectable = false;
    } else {
      classNames.push('future-date');
    }

    if (date.getDay() === 0) {
      classNames.push('day-sunday');
    } else if (date.getDay() === 6) {
      classNames.push('day-saturday');
    } else if (holidaysData[ymd]) {
      classNames.push('day-holiday');
    } else {
      classNames.push('day-weekday');
    }

    return [isSelectable, classNames.join(' '), null];
  }

  function getCalendarStartDate(drawYear, drawMonth) {
    const isCurrentMonth = drawYear === today.getFullYear() && drawMonth === today.getMonth();
    const referenceDate = isCurrentMonth ? today : new Date(drawYear, drawMonth, 1);
    const startDate = new Date(referenceDate);
    startDate.setDate(startDate.getDate() - startDate.getDay());
    return startDate;
  }

  function getDayLabel(date) {
    return date.getDate() === 1 ? `${date.getMonth() + 1}/1` : date.getDate();
  }

  // 日付範囲のオプションを生成し、<select>に追加
  function populateDateSelect() {
    let currentDate = new Date(today);

    while (currentDate <= maxDate) {
      if (isCheckHolidays(currentDate)) {
        currentDate.setDate(currentDate.getDate() + 1);
        continue;
      }

      const optionText = $.datepicker.formatDate('yy-mm-dd', currentDate);
      const displayText = `${currentDate.getFullYear()}年${currentDate.getMonth()+1}月${currentDate.getDate()}日`;
      $tourDateDisplay.append($("<option>").val(optionText).text(displayText));
      currentDate.setDate(currentDate.getDate() + 1); // 次の日付に移動
    }
    $tourDateDisplay.val($.datepicker.formatDate('yy-mm-dd', today)).change();
  }

  populateDateSelect(); // ページ読み込み時に <select> に日付オプションを追加

  if($tourDateDisplay.val()){
    $hiddenTourDate.val(createDateFormat($tourDateDisplay.val()));
  }

  // <select> の変更イベントで hidden フィールド及びカレンダーの高さを更新
  $tourDateDisplay.on('change', function() {
    const dateText = $(this).val();
    $hiddenTourDate.val(createDateFormat(dateText));
    $datepickerContainer.datepicker("setDate", dateText);
    renderSixRows(dateText);
  });

  function ensureDateOption(dateText) {
    if ($tourDateDisplay.find(`option[value="${dateText}"]`).length > 0) return;

    const date = new Date(dateText);
    const displayText = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    $tourDateDisplay.append($("<option>").val(dateText).text(displayText));
  }

  function selectDate(dateText) {
    ensureDateOption(dateText);
    $tourDateDisplay.val(dateText).trigger('change');
  }

  // 6行固定描画
  function renderSixRows(selectedDate){
    const inst = $datepickerContainer.data("datepicker");
    if(!inst) return;

    const drawYear = inst.drawYear;
    const drawMonth = inst.drawMonth;
    const startDate = getCalendarStartDate(drawYear, drawMonth);

    const $tbody = $datepickerContainer.find(".ui-datepicker-calendar tbody");
    $tbody.empty();

    let currentDate = new Date(startDate);
    for(let row=0; row<6; row++){
      const $tr = $("<tr></tr>");
      for(let col=0; col<7; col++){
        const ymd = $.datepicker.formatDate('yy-mm-dd', currentDate);
        const result = getDateState(currentDate);
        const isSelectable = result[0];
        const className = result[1] + (currentDate.getMonth()!==drawMonth?' ui-datepicker-other-month':'');
        const dayLabel = getDayLabel(currentDate);

        const $td = $("<td></td>").addClass(className);
        if(isSelectable){
          const $a = $("<a></a>").addClass("ui-state-default").text(dayLabel).attr("data-date", ymd);
          if(selectedDate && ymd===selectedDate) $a.addClass("ui-state-active");
          $td.append($a);
        } else {
          $td.append($("<span></span>").addClass("ui-state-default").text(dayLabel));
        }
        $tr.append($td);
        currentDate.setDate(currentDate.getDate()+1);
      }
      $tbody.append($tr);
    }
  }

  $.get("https://holidays-jp.github.io/api/v1/date.json", function(data) {
    holidaysData = data;

    $datepickerContainer.datepicker({
      showOtherMonths:true,
      selectOtherMonths:true,
      beforeShowDay: getDateState,
      dateFormat: 'yy-mm-dd',
      minDate: 0,
      maxDate: maxDate,
      onSelect: selectDate,
      beforeShow:function(){ setTimeout(()=>renderSixRows($tourDateDisplay.val()),0); },
      onChangeMonthYear:function(){ setTimeout(()=>renderSixRows($tourDateDisplay.val()),0); },
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      dayNames: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
      dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
      showMonthAfterYear: true,
      yearSuffix: '年',
      prevText: '前の月',
      nextText: '次の月',
      showButtonPanel: false
    });

    // 初期表示も6行描画
    setTimeout(()=>renderSixRows($tourDateDisplay.val()),100);
  });

  // 日付クリックハンドラ（セレクトボックス同期）
  $datepickerContainer.on("click","a.ui-state-default",function(){
    const dateText = $(this).attr("data-date");
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateText)) return;
    selectDate(dateText);
  });
});


/**
 * 寺院検索クエリパラメーター送信
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.form-search').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // フォーム値→クエリへ
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [key, val] of fd.entries()) {
        const v = (val ?? '').toString().trim();
        if (v !== '') params.append(key, v);
      }

      // plan-xxx上で、値が何も無ければ /search に飛ばす
      const isPlanPage = /^\/plan-[^/]+\/?$/.test(window.location.pathname);
      const hasAnyParam = params.toString() !== '';

      const url = new URL(form.action || window.location.pathname, window.location.origin);

      if (isPlanPage && !hasAnyParam) {
        url.pathname = '/search';
        url.search = '';
      } else {
        // 既存クエリは使わず、フォーム値だけで組み直す
        url.search = params.toString();
      }

      window.location.href = url.toString();
    });

    // 条件クリアボタン（完全リロード版）
    const clearBtn = form.querySelector('.btn-clear');

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();

        window.location.href = window.location.origin + '/search';
      });
    }
  });
});


/**
 * 郵便番号自動入力
 */
const zipAutoFill = () => {
  const zipcodeInput = document.getElementById("zipcode");
  const prefInput = document.getElementById("prefecture");
  const cityInput = document.getElementById("city");
  const addressInput = document.getElementById("address");
  const address1Input = document.getElementById("address1");
  const addressTownInput = document.getElementById("address-town");
  const searchButton = document.getElementById("zipcode-search");

  if (!zipcodeInput || !prefInput || !cityInput || !addressInput || !address1Input || !addressTownInput || !searchButton) return;
  const errorText = zipcodeInput.parentElement.querySelector("[data-zipcode-error]");

  const showError = message => {
    if (!errorText) return;
    errorText.textContent = message;
    errorText.style.display = message ? "block" : "none";
  };

  // 郵便番号入力時は数字7桁への整形のみ行う（自動検索はしない）
  zipcodeInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "").slice(0, 7);
    showError("");
  });

  // 「住所を検索する」ボタン押下で住所を検索
  searchButton.addEventListener("click", () => {
    const zipcode = zipcodeInput.value.replace(/[^0-9]/g, "").slice(0, 7);
    zipcodeInput.value = zipcode;

    if (zipcode.length !== 7) {
      showError("郵便番号は7桁で入力してください");
      return;
    }

    showError("");

    fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`)
      .then(res => res.json())
      .then(data => {
        if (data.results) {
          const result = data.results[0];
          // Pardotへは項目別に連携（都道府県・市区町村は hidden で保持）
          prefInput.value = result.address1;
          cityInput.value = result.address2;
          // 表示用の住所1は「都道府県＋市区町村＋町域」を結合（グレーアウト・編集不可）
          address1Input.value = `${result.address1}${result.address2}${result.address3}`;
          // 町域は送信時に「その他住所・番地」の先頭へ結合するため保持（住所2は丁目以降を手入力）
          addressTownInput.value = result.address3;
          // 住所1の必須エラー表示・赤背景を解除
          address1Input.classList.remove("_required");
          const address1Error = document.querySelector('[data-required-error="prefecture"]');
          if (address1Error) address1Error.style.display = "none";
        } else {
          showError("郵便番号に該当する住所が見つかりませんでした");
        }
      })
      .catch(() => {
        showError("住所の検索に失敗しました。時間をおいて再度お試しください");
      });
  });
};

/**
 * ご自宅から寺院までの距離シミュレーター
 */
const templeDistance = () => {
  const section = document.getElementById("js-temple-distance");
  if (!section) return;

  const panel = document.getElementById("js-temple-distance-panel");
  const zipInput = document.getElementById("js-temple-distance-zip");
  const submitButton = document.getElementById("js-temple-distance-submit");
  const errorText = document.getElementById("js-temple-distance-error");
  const result = document.getElementById("js-temple-distance-result");

  const templeName = section.dataset.templeName;
  const temple = {
    lat: parseFloat(section.dataset.templeLat),
    lng: parseFloat(section.dataset.templeLng)
  };

  const WALK_DETOUR_RATE = 1.42;
  const CAR_DETOUR_RATE = 1.35;
  const WALK_SPEED_KMH = 4.8;
  const CAR_SPEED_KMH = 32;
  const WALKABLE_LIMIT_KM = 100;

  const toRadian = degree => degree * Math.PI / 180;

  const straightDistance = (from, to) => {
    const earthRadiusKm = 6371;
    const deltaLat = toRadian(to.lat - from.lat);
    const deltaLng = toRadian(to.lng - from.lng);
    const haversine = Math.sin(deltaLat / 2) ** 2
      + Math.cos(toRadian(from.lat)) * Math.cos(toRadian(to.lat)) * Math.sin(deltaLng / 2) ** 2;

    return 2 * earthRadiusKm * Math.asin(Math.min(1, Math.sqrt(haversine)));
  };

  const formatDistance = km => {
    if (km < 1) return `${Math.round(km * 1000)}m`;
    if (km < 10) return `${km.toFixed(1)}km`;

    return `${Math.round(km)}km`;
  };

  const formatDuration = minutes => {
    const total = Math.max(1, Math.round(minutes));
    if (total < 60) return `約 <span class="_num">${total}</span>分`;

    const hours = Math.floor(total / 60);
    const rest = total % 60;
    const restText = rest > 0 ? ` <span class="_num">${rest}</span>分` : "";

    return `約 <span class="_num">${hours}</span>時間${restText}`;
  };

  const showError = message => {
    errorText.textContent = message;
    errorText.hidden = !message;
  };

  const renderWalk = (km, minutes) => {
    const timeElement = document.getElementById("js-temple-distance-walk-time");
    const distElement = document.getElementById("js-temple-distance-walk-dist");

    if (km > WALKABLE_LIMIT_KM) {
      timeElement.innerHTML = "—";
      distElement.textContent = "徒歩圏外";
      return;
    }

    timeElement.innerHTML = formatDuration(minutes);
    distElement.textContent = `約 ${formatDistance(km)} の道のり`;
  };

  const renderCar = (km, minutes) => {
    document.getElementById("js-temple-distance-car-time").innerHTML = formatDuration(minutes);
    document.getElementById("js-temple-distance-car-dist").textContent = `約 ${formatDistance(km)} の道のり`;
  };

  const renderVerdict = minutes => {
    const rounded = Math.max(1, Math.round(minutes));
    const verdictElement = document.getElementById("js-temple-distance-verdict");
    const verdictContainer = verdictElement.closest(".temple-distance__verdict");

    if (rounded > 30) {
      verdictContainer.hidden = true;
      return;
    }

    verdictContainer.hidden = false;
    verdictElement.textContent = `ご家族での見学もしやすく、${templeName}が最もおすすめできる距離感です。`;
  };

  const render = place => {
    const straightKm = straightDistance({ lat: place.lat, lng: place.lng }, temple);
    const walkKm = straightKm * WALK_DETOUR_RATE;
    const carKm = straightKm * CAR_DETOUR_RATE;
    const walkMinutes = walkKm / WALK_SPEED_KMH * 60;
    const carMinutes = carKm / CAR_SPEED_KMH * 60;

    document.getElementById("js-temple-distance-from").textContent = place.address;
    document.getElementById("js-temple-distance-straight").textContent = formatDistance(straightKm);
    renderWalk(walkKm, walkMinutes);
    renderCar(carKm, carMinutes);
    renderVerdict(carMinutes);

    result.hidden = false;
    panel.classList.add("_searched");
  };

  const search = () => {
    const zipcode = zipInput.value.replace(/[^0-9]/g, "").slice(0, 7);
    zipInput.value = zipcode;

    if (zipcode.length !== 7) {
      showError("郵便番号は7桁で入力してください");
      return;
    }

    showError("");
    submitButton.disabled = true;

    resolvePostal(zipcode)
      .then(place => {
        if (!place) {
          showError("この郵便番号は判定できませんでした。7桁の郵便番号をご確認ください");
          return;
        }
        render(place);
      })
      .finally(() => {
        submitButton.disabled = false;
      });
  };

  zipInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "").slice(0, 7);
    showError("");
  });

  zipInput.addEventListener("keydown", event => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    search();
  });

  submitButton.addEventListener("click", search);
};

/**
 * フォームのGET送信（ステップ遷移）とGA4連携を制御する関数
 */
function diagnosticStepControl() {
    const mainForm = document.getElementById('js-ohaka-check-form');
    const stepInput = document.getElementById('js-ohaka-check-step-input');
    if (!mainForm || !stepInput) return;

    // ページロード時に現在のステップ閲覧イベントをGTMに発火
    sendGA4(window.location.pathname + window.location.search, stepInput.value);

    // 【STEP1用】チェックボックスの選択状態に応じて「次へ」ボタンのdisabledを制御
    if (stepInput.value === '1') {
        const step1NextBtn = mainForm.querySelector('.ohaka-check-next-trigger');

        if (step1NextBtn) {
            const updateStep1ButtonState = () => {
                const checkedCount = mainForm.querySelectorAll('input[type="checkbox"]:checked').length;
                step1NextBtn.disabled = checkedCount < 1;
            };

            updateStep1ButtonState();

            // 戻ってきたときの挙動を安定させるため、change だけでなく click も包括して監視
            mainForm.addEventListener('click', function (e) {
                if (e.target.type === 'checkbox') {
                    updateStep1ButtonState();
                }
            });
            mainForm.addEventListener('change', function (e) {
                if (e.target.type === 'checkbox') {
                    updateStep1ButtonState();
                }
            });
        }
    }

    // ラジオボタン選択時の装飾クラストグル
    mainForm.addEventListener('change', function (e) {
        const target = e.target;
        if (target.type === 'radio') {
            const group = target.closest('.ohaka-check-radio-group').querySelectorAll('input[type="radio"]');
            group.forEach(input => input.closest('label').classList.remove('ohaka-check-is-selected'));

            const label = target.closest('label');
            if (label) label.classList.add('ohaka-check-is-selected');
        }
    });

    document.addEventListener('click', function (e) {
        // クリックされた要素、またはその親要素（ボタン自身）を取得
        const nextBtn = e.target.closest('.ohaka-check-next-trigger');
        const prevBtn = e.target.closest('.ohaka-check-prev-trigger');

        // 「次へ」ボタンが押された場合
        if (nextBtn) {
            if (nextBtn.disabled) return;

            // STEP1で1つもチェックがなければ送信をブロック
            const checkedCount = mainForm.querySelectorAll('input[type="checkbox"]:checked').length;
            if (stepInput.value === '1' && checkedCount < 1) {
                return;
            }
            submitToStep(nextBtn.getAttribute('data-next'));
        }

        // 「戻る」ボタンが押された場合
        if (prevBtn) {
            if (prevBtn.disabled) return;
            submitToStep(prevBtn.getAttribute('data-prev'));
        }
    });

    // 最終「結果を見る」ボタンのハンドリング
    const submitBtn = document.getElementById('js-ohaka-check-submit');
    if (submitBtn) {
        submitBtn.addEventListener('click', function () {
            submitToStep('result');
        });
    }

    // ラジオボタンの変更を監視して自動遷移
    const radioInputs = mainForm.querySelectorAll('.ohaka-check-radio-group input[type="radio"]');
    radioInputs.forEach(function (input) {
        input.addEventListener('click', function () {
            const nextStep = this.getAttribute('data-next');
            if (nextStep) {
                setTimeout(function () {
                    submitToStep(nextStep);
                }, 200);
            }
        });
    });

    // フォームを送信してページリロード（ステップ遷移）をかける共通処理
    function submitToStep(stepId) {
        stepInput.value = stepId;
        mainForm.submit();
    }

    // GTM（Googleタグマネージャー）連携内部関数
    function sendGA4(pagePath, stepId) {
        const pageTitle = document.title + (stepId === 'result' ? ' - 診断結果' : ` - フォームStep ${stepId}`);

        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                'event': 'ohaka_check_step',
                'virtual_page_path': pagePath,
                'virtual_page_title': pageTitle,
                'diagnostic_step': stepId
            });
        }
    }
}

/**
 * GET送信によるステップ遷移を制御する関数
 * ohaka-checkのdiagnosticStepControl()と同じ「自己URL宛てGET再送信」方式だが、
 * STEP2〜4は次へ進む前にvalidateStepFields()でテキスト入力のバリデーションを行う。
 */
function documentRequestStepControl() {
    document.addEventListener('change', function (e) {
        const target = e.target;
        if (target.type === 'radio') {
            const group = target.closest('.ohaka-check-radio-group');
            if (!group) return;
            group.querySelectorAll('input[type="radio"]').forEach(function (input) {
                input.closest('label').classList.remove('ohaka-check-is-selected');
            });
            const label = target.closest('label');
            if (label) label.classList.add('ohaka-check-is-selected');
        }
    });

    const mainForm = document.getElementById('js-document-request-step-form');
    const stepInput = document.getElementById('js-document-request-step-input');
    if (!mainForm || !stepInput) return;

    /**
     * 個人情報の入力値をCookieへ退避し、GETのURLに載らないよう送信対象から外す
     */
    function detachPiiFields() {
        FORM_COOKIE_FIELDS.forEach(function (fieldName) {
            mainForm.querySelectorAll(`[name="${fieldName}"]`).forEach(function (input) {
                setFormCookie(fieldName, input.value, 1);
                input.disabled = true;
            });
        });
    }

    function submitToStep(stepId) {
        stepInput.value = stepId;
        detachPiiFields();
        mainForm.submit();
    }

    mainForm.querySelectorAll('.js-document-request-next').forEach(function (btn) {
        btn.addEventListener('click', function () {
            const stepContainer = this.closest('form').querySelector('.ohaka-check-step.active');
            const { isValid, firstErrorElement } = validateStepFields($(stepContainer));
            if (!isValid) {
                focusFirstError($(stepContainer), firstErrorElement);
                return;
            }
            submitToStep(this.getAttribute('data-next'));
        });
    });

    mainForm.querySelectorAll('.ohaka-check-prev-trigger').forEach(function (btn) {
        btn.addEventListener('click', function () {
            submitToStep(this.getAttribute('data-prev'));
        });
    });
}

/**
 * 埋め込みCTAコンポーネント：3つまで選択の制限と専用ページへの遷移を制御する関数
 */
function ctaComponent() {
    const q1Containers = document.querySelectorAll('#js-ohaka-check-cta-box, #js-ohaka-check-cta-box-component');
    if (!q1Containers.length) return;

    q1Containers.forEach(container => {
        const checkboxes = container.querySelectorAll('input[type="checkbox"]');
        // CTA用の「次へ進む」ボタンをコンテナ起点、またはdocumentから探す
        const ctaNextBtn = document.getElementById('js-ohaka-check-cta-next-btn');

        function checkLimit() {
            const checkedCount = container.querySelectorAll('input[type="checkbox"]:checked').length;
            checkboxes.forEach(chk => {
                if (!chk.checked) {
                    chk.disabled = checkedCount >= 3;
                }
            });

            // CTA用のボタンの有効・無効をチェックボックスの数で切り替える
            if (ctaNextBtn) {
                ctaNextBtn.disabled = checkedCount < 1;
            }
        }

        checkLimit();

        container.addEventListener('change', function (e) {
            const target = e.target;
            if (target.type === 'checkbox') {
                const label = target.closest('label');
                if (!label) return;

                if (target.checked) label.classList.add('ohaka-check-is-selected');
                else label.classList.remove('ohaka-check-is-selected');

                checkLimit();
            }
        });
    });

    const ctaNextBtn = document.getElementById('js-ohaka-check-cta-next-btn');
    if (ctaNextBtn) {
        ctaNextBtn.addEventListener('click', function () {
            // disabled状態（未選択）ならクリックイベント自体を無視して遷移させない
            if (this.disabled) return;

            const ctaContainer = document.getElementById('js-ohaka-check-cta-box-component') || document.getElementById('js-ohaka-check-cta-box');
            if (!ctaContainer) return;

            const checkboxesQ1 = ctaContainer.querySelectorAll('input[data-ohaka-check-q1]');
            const selectedQ1 = [];

            checkboxesQ1.forEach(chk => {
                if (chk.checked) {
                    selectedQ1.push(chk.getAttribute('data-ohaka-check-q1'));
                }
            });

            const baseUrl = ctaContainer.dataset.ohakaCheckUrl;
            window.location.href = `${baseUrl}?step=2&q1=${selectedQ1.join(',')}`;
        });
    }
}

/**
 * 他県の市区町村を完全に非表示・除外する連動関数
 */
function prefCityLinkage() {
    const prefSelect = document.getElementById('ohaka-check-pref');
    const citySelect = document.getElementById('ohaka-check-city');
    if (!prefSelect || !citySelect) return;

    const allCityOptions = Array.from(citySelect.querySelectorAll('option[data-parent]'));

    function updateCityOptions() {
        const selectedPref = prefSelect.value;
        const currentSelectedValue = citySelect.value;

        citySelect.innerHTML = '<option value="">市区町村を選択</option>';

        if (!selectedPref) {
            citySelect.disabled = true;
            return;
        }

        let matchCount = 0;
        allCityOptions.forEach(opt => {
            if (opt.getAttribute('data-parent') === selectedPref) {
                const clonedOpt = opt.cloneNode(true);
                if (clonedOpt.value === currentSelectedValue) {
                    clonedOpt.selected = true;
                }
                citySelect.appendChild(clonedOpt);
                matchCount++;
            }
        });

        citySelect.disabled = matchCount === 0;
    }

    prefSelect.addEventListener('change', updateCityOptions);
    updateCityOptions();
}

/**
 * 共通ページネーションリンクを診断専用URLに書き換える関数
 */
function paginationUrlCustom() {
    const pagiNav = document.getElementById('js-diagnose-pagination');
    if (!pagiNav) return;

    const links = pagiNav.getElementsByTagName('a');
    const currentUrl = new URL(window.location.href);
    const q1 = currentUrl.searchParams.get('q1') || '';
    const q2 = currentUrl.searchParams.get('q2') || '';
    const q3 = currentUrl.searchParams.get('q3') || '';
    const pref = currentUrl.searchParams.get('pref') || '';
    const city = currentUrl.searchParams.get('city') || '';

    const basePageUrl = window.location.origin + window.location.pathname;

    for (let i = 0; i < links.length; i++) {
        const href = links[i].getAttribute('href');
        if (!href) continue;

        let pageNum = 1;
        const match = href.match(/[?&]paged=(\d+)/) || href.match(/\/page\/(\d+)/);
        if (match) {
            pageNum = match[1];
        } else {
            const textNum = parseInt(links[i].innerText.trim(), 10);
            if (!isNaN(textNum)) {
                pageNum = textNum;
            }
        }

        const newUrl = basePageUrl + '?step=result&q1=' + encodeURIComponent(q1) +
            '&q2=' + encodeURIComponent(q2) +
            '&q3=' + encodeURIComponent(q3) +
            '&pref=' + encodeURIComponent(pref) +
            '&city=' + encodeURIComponent(city) +
            '&check_page=' + pageNum;

        links[i].setAttribute('href', newUrl);
    }
}

/**
 * 資料ダウンロードページ：市区町村チェックボックスによるカード絞り込み機能
 */
const downloadCityFilter = () => {
    const areas = document.querySelectorAll('.download__area');

    areas.forEach(area => {
        const checkboxes = area.querySelectorAll('.js-city-checkbox');
        const cards = area.querySelectorAll('.js-download-card');

        checkboxes.forEach(cb => {
            cb.checked = false;
            cb.addEventListener('change', () => filterAreaCards(checkboxes, cards));
        });

        function filterAreaCards(checkboxes, cards) {
            const selectedCities = Array.from(checkboxes)
                .filter(cb => cb.checked)
                .map(cb => cb.value);

            cards.forEach(card => {
                const cardCity = card.dataset.city;

                if (selectedCities.length === 0 || selectedCities.includes(cardCity)) {
                    card.style.display = '';
                } else {
                    card.style.display = 'none';
                }
            });
        }
    });
};
